import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { deepCamelCase } from './camel-case.util';

@Injectable()
export class CamelCaseInterceptor implements HttpInterceptor {
	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(
			map(event => {
				if (event instanceof HttpResponse && event.body && !req.url.includes('/assets/')) {
					return event.clone({ body: deepCamelCase(event.body) });
				}
				return event;
			})
		);
	}
}
